import React, { useState } from 'react';
import { CustomSelect, Dropdown } from '@fourthwall/components';
import * as S from './styled';
const SORTING_STRATEGY_OPTIONS = [
    {
        value: 'MANUAL',
        label: 'Manual order',
        description: 'Drag and drop products to arrange them in your preferred order.',
    },
    {
        value: 'BEST_SELLING',
        label: 'Best selling first',
        description: 'Products with the most sales will appear first in your collection.',
    },
    {
        value: 'NEWEST',
        label: 'Newest products first',
        description: 'Recently added products will appear first in your collection.',
    },
    {
        value: 'OLDEST',
        label: 'Oldest products first',
        description: 'Older products will appear first in your collection.',
    },
    {
        value: 'NAME_ASC',
        label: 'Product name (A to Z)',
        description: 'Products will be sorted alphabetically from A to Z.',
    },
    {
        value: 'NAME_DESC',
        label: 'Product name (Z to A)',
        description: 'Products will be sorted alphabetically from Z to A.',
    },
];
export const SortingStrategySelect = ({ name, label, value, disabled = false, error, helperText, onValueChange, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const selectedOption = SORTING_STRATEGY_OPTIONS.find((option) => option.value === value);
    const displayValue = selectedOption?.label || '';
    const handleSelect = (selectedValue) => {
        onValueChange?.(selectedValue);
        setIsOpen(false);
    };
    const renderDropdownContent = () => {
        return SORTING_STRATEGY_OPTIONS.map((option) => (React.createElement(Dropdown.Item, { key: option.value, label: React.createElement(S.OptionContent, null,
                React.createElement(S.OptionTitle, null, option.label),
                React.createElement(S.OptionDescription, null, option.description)), onClick: () => handleSelect(option.value), active: option.value === value })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Dropdown, { isOpen: isOpen, content: renderDropdownContent(), position: "bottom-start", maxWidth: 600, onClose: () => setIsOpen(false) },
            React.createElement(CustomSelect, { name: name, label: label, value: displayValue, disabled: disabled, error: error, onSelect: () => !disabled && setIsOpen(!isOpen) })),
        helperText && React.createElement(S.HelperText, null, helperText)));
};
